"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const isString_1 = __importDefault(require("lodash/isString"));
const styled_1 = __importDefault(require("../utils/styled"));
const ContextMenu_Item_1 = __importStar(require("./ContextMenu.Item"));
const useUniqueId_1 = require("../useUniqueId");
const useListbox_1 = require("../useListbox");
const ContextMenu_Popout_1 = __importDefault(require("./ContextMenu.Popout"));
const isChildAFunction = (children) => typeof children === "function";
const Container = styled_1.default.div(({ isOpen, theme, side: align }) => ({
    label: "contextmenu",
    cursor: "pointer",
    outline: "none",
    position: "relative",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    justifyContent: align === "left" ? "flex-start" : "flex-end",
    zIndex: isOpen ? theme.zIndex.selectOptions + 1 : theme.zIndex.selectOptions,
}));
/**
 * Overlay to prevent mouse events when the context menu is open
 */
const InvisibleOverlay = styled_1.default("div")(({ theme }) => ({
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    cursor: "default",
    zIndex: theme.zIndex.selectOptions + 1,
}));
const Separator = styled_1.default.div `
  padding: ${({ theme }) => theme.space.small}px 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};

  ::after {
    content: "";
    height: 1px;
    width: 100%;
    background-color: ${({ theme }) => theme.color.border.select};
  }
`;
const ContextMenu = (_a) => {
    var { containerRef, id, align = "left", embedChildrenInMenu = false, keepOpenOnItemClick, condensed, iconLocation, children, items, onClick, onOutsideClick, disabled, width, open, anchored } = _a, props = __rest(_a, ["containerRef", "id", "align", "embedChildrenInMenu", "keepOpenOnItemClick", "condensed", "iconLocation", "children", "items", "onClick", "onOutsideClick", "disabled", "width", "open", "anchored"]);
    const $invisibleOverlay = React.useRef(null);
    const uniqueId = useUniqueId_1.useUniqueId(id);
    const { isOpen, setIsOpen, buttonProps, listboxProps, getChildProps, focusedOptionIndex } = useListbox_1.useListbox({
        itemCount: items.length,
        isMultiSelect: keepOpenOnItemClick,
        isDisabled: disabled,
        initiallyOpen: open,
    });
    React.useEffect(() => {
        if (isOpen && setIsOpen) {
            const hideOnScroll = () => setIsOpen(false);
            document.addEventListener("scroll", hideOnScroll);
            return () => {
                document.removeEventListener("scroll", hideOnScroll);
            };
        }
    }, [isOpen, setIsOpen]);
    React.useEffect(() => {
        if (!items) {
            throw new Error("No array of items has been provided for the ContextMenu.");
        }
    }, [items]);
    const renderedChildren = React.useMemo(() => (isChildAFunction(children) ? children(isOpen ? isOpen : false) : children), [isOpen, children]);
    const currentItem = React.useMemo(() => {
        if (focusedOptionIndex === null || focusedOptionIndex === undefined) {
            return;
        }
        return items[focusedOptionIndex];
    }, [focusedOptionIndex, items]);
    const handleSelect = React.useCallback(() => {
        if (!currentItem) {
            return;
        }
        if (currentItem.onClick) {
            currentItem.onClick(currentItem);
        }
        if (onClick) {
            onClick(currentItem);
        }
    }, [currentItem, onClick]);
    const overlay = (React.createElement(InvisibleOverlay, { ref: $invisibleOverlay, onClick: e => {
            e.stopPropagation();
            setIsOpen && setIsOpen(false);
            if (onOutsideClick) {
                onOutsideClick();
            }
        } }));
    return (React.createElement(React.Fragment, null,
        isOpen && (anchored ? overlay : react_dom_1.createPortal(overlay, document.body)),
        React.createElement(Container, Object.assign({}, props, { isOpen: isOpen || false, side: align, onClick: e => {
                e.stopPropagation();
                if (keepOpenOnItemClick && isOpen) {
                    return;
                }
                if (!disabled && setIsOpen) {
                    setIsOpen(!isOpen);
                }
            }, onKeyDown: e => {
                switch (e.key) {
                    case "Enter":
                        e.stopPropagation();
                        handleSelect();
                        break;
                }
            } }),
            React.createElement("div", Object.assign({ style: { outline: "none", width: "100%" } }, buttonProps), renderedChildren),
            isOpen && (React.createElement(ContextMenu_Popout_1.default, Object.assign({}, listboxProps, { key: `ContextMenuPopout-${uniqueId}-${items.length}-items`, ref: containerRef, condensed: Boolean(condensed), numRows: items.length, align: align, embedChildrenInMenu: embedChildrenInMenu, container: $invisibleOverlay, rowHeight: ContextMenu_Item_1.rowHeight, anchored: Boolean(anchored) }),
                embedChildrenInMenu && renderedChildren,
                items.map((item, index) => (React.createElement(React.Fragment, { key: index },
                    (item.separator === "top" || item.separator === "both") && React.createElement(Separator, null),
                    React.createElement(ContextMenu_Item_1.default, Object.assign({ id: `operational-ui__ContextMenuItem-${uniqueId}-${index}`, isActive: typeof item !== "string" && item.isActive, condensed: condensed, align: align, iconLocation: iconLocation, width: width || "min-content", item: item, disabled: isString_1.default(item) ? !onClick : !item.onClick && !onClick, onClick: e => {
                            e.stopPropagation(); // clicking on an item should not trigger the parent's onClick
                            if (!keepOpenOnItemClick && setIsOpen) {
                                setIsOpen(false);
                            }
                            if (!isString_1.default(item) && item.onClick) {
                                item.onClick(item);
                            }
                            if (onClick) {
                                onClick(item);
                            }
                        } }, (getChildProps ? getChildProps(index) : {}))),
                    (item.separator === "bottom" || item.separator === "both") && React.createElement(Separator, null))))))),
        isOpen && (React.createElement("div", { style: { position: "absolute", zIndex: -1, width: 0, height: 0 }, tabIndex: 0, "data-cy": "operational-ui__ContextMenu-focus-trap", onFocus: () => setIsOpen && setIsOpen(false), "aria-hidden": "true" }))));
};
exports.default = ContextMenu;
//# sourceMappingURL=ContextMenu.js.map